<template>
  <layout>
    <page-header :header="$t('coupons.edit_coupon')" />
    <div class="content">
      <resource-form
        :id="$route.params.id"
        @saved="returnBack"
        @cancelled="returnBack"
      />
    </div>
  </layout>
</template>

<script>
import ResourceForm from './Form.vue'

const resourceBase = 'coupons'

export default {
  name: 'CouponsEdit',

  components: {
    ResourceForm,
  },

  methods: {
    returnBack() {
      this.$router.push({ name: `${resourceBase}` })
    },
  },
}
</script>
